import Base from './Base.vue'
import Edit from './Edit.vue'
import Users from './Users.vue'
import Addresses from './Addresses.vue'
import AddressesCreate from './AddressesCreate.vue'
import History from './History.vue'
import HistoryDetail from './HistoryDetail.vue'
import Backorders from './Backorders.vue'
import EditUser from './EditUser.vue'
import Invoices from './Invoices.vue'

export default {
    Base,
    Edit,
    Users,
    Addresses,
    AddressesCreate,
    HistoryDetail,
    History,
    Backorders,
    EditUser,
    Invoices,
}



// WEBPACK FOOTER //
// ./src/views/customer/account/index.js